import { InvestmentEntityTypeEnumType } from '__generated__/graphql';

// KYC country is stored as an ISO-2 code ('IN') when captured through the
// onboarding KYC select, but Kyc/UpdateKycAddress.tsx writes it as free text,
// so live rows also hold values like 'India' or 'india'.
const INDIAN_COUNTRY_VALUES = ['IN', 'INDIA'];

const normaliseCountry = (country?: string | null): string => (country || '').trim().toUpperCase();

export const isIndianCountryValue = (country?: string | null): boolean =>
  INDIAN_COUNTRY_VALUES.includes(normaliseCountry(country));

export const isIndianResidentEntity = (
  investmentEntity?: {
    type?: InvestmentEntityTypeEnumType | null;
    kyc?: { address?: { country?: string | null } | null } | null;
  } | null
): boolean => {
  if (!investmentEntity) return false;
  if (investmentEntity.type !== InvestmentEntityTypeEnumType.Individual) return false;

  return isIndianCountryValue(investmentEntity.kyc?.address?.country);
};
